import {types} from './types';

const initialState = {
    withdrawals: {
        data: [],
        countPage: 0
    },
}

export function withdrawalsReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_WITHDRAWALS:
            return { ...state, withdrawals: action.payload};
        default:
            return state
    }
}